import { ReactElement } from 'react';

import { cn } from '../../utils';

import styles from './styles.module.scss';

interface LoaderProps {
  size: 'small' | 'medium';
  theme: 'black' | 'colored';
}

export const Loader = ({
  size = 'medium',
  theme = 'black',
}: LoaderProps): ReactElement => (
  <div className={cn([styles.wrapper, styles[size]])}>
    <div className={cn([styles.dots, styles.three])}>
      <div className={cn([styles.dot, styles[size], styles[theme]])} />
      <div className={cn([styles.dots, styles.two])}>
        <div className={cn([styles.dot, styles[size], styles[theme]])} />
        <div className={cn([styles.dot, styles[size], styles[theme]])} />
      </div>
    </div>
  </div>
);
